<template>
    <div class="p-8">
        <h4>OPEN HOUSE</h4>
        <ul class="open-house">
            <li
                class="p-2 md:p-4"
                v-for="(openhouse, idx) in openhouses"
                :key="'open-house-' + idx"
            >
                &bullet;
                <span class="openhouse-notes" v-html="openhouse.notes"></span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: ["openhouses"],
    methods: {},
    data() {
        return {};
    }
};
</script>
